import MessageTextItemComponent from "./MessageTextItemComponent";

export default MessageTextItemComponent;
